import { render, staticRenderFns } from "./LowStockNotification.vue?vue&type=template&id=61bab925&scoped=true&"
import script from "./LowStockNotification.vue?vue&type=script&lang=js&"
export * from "./LowStockNotification.vue?vue&type=script&lang=js&"
import style0 from "./LowStockNotification.vue?vue&type=style&index=0&id=61bab925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bab925",
  null
  
)

export default component.exports